export const stepsDescr = [
  "Confirm Your Personal Information",
  "Confirm Your Address",
];

export const stepsCount = stepsDescr.length;
